import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	showMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActionsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	done: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inProgress: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	toDo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	empty: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	releaseVersionsTableLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	showMore: {
		id: 'project-versions.table.show-more',
		defaultMessage: 'Show {count} more',
		description: 'Button that when clicked, loads next page of versions',
	},
	moreActionsLabel: {
		id: 'project-versions.table.more-actions-label',
		defaultMessage: 'More actions',
		description: 'Label for the more actions menu',
	},
	done: {
		id: 'project-versions.table.done',
		defaultMessage: '{done} done',
		description: '',
	},
	inProgress: {
		id: 'project-versions.table.in-progress',
		defaultMessage: '{inProgress} in progress',
		description: '',
	},
	toDo: {
		id: 'project-versions.table.to-do',
		defaultMessage: '{toDo} to do',
		description: '',
	},
	empty: {
		id: 'project-versions.table.empty',
		defaultMessage: 'No issues',
		description: '',
	},
	emptyIssueTermRefresh: {
		id: 'project-versions.table.empty-issue-term-refresh',
		defaultMessage: 'No work items',
		description: '',
	},
	releaseVersionsTableLabel: {
		id: 'project-versions.table.release-versions-label',
		defaultMessage: 'Release versions',
		description: 'Label for the release versions table',
	},
});
export default messages;
